import script from "./TagView.vue?vue&type=script&lang=ts&setup=true"
export * from "./TagView.vue?vue&type=script&lang=ts&setup=true"

import "./TagView.vue?vue&type=style&index=0&id=e88c1668&lang=less&scoped=true"

import exportComponent from "D:\\myWork\\番顺茶叶官网\\panshunwebsite\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e88c1668"]])

export default __exports__